module.exports = __webpack_public_path__ + "img/cf.d95f6e2a.svg";